import React, { useEffect, useState } from "react";
import MainLayout from "../components/Layout/MainLayout";
import { Button, Dropdown, Space, Breadcrumb } from "antd";
import SearchInput from "../components/Forms/SearchInput";
import { FaCaretDown, FaHeart } from "react-icons/fa";
import {
  useNavigate,
  useSearchParams,
  Link,
  useLocation,
  useOutletContext,
} from "react-router-dom";
import FileUploadModal from "../components/models/FileUploadModal";
import { postApi, useApiCall } from "../services/api";
import { items, roleIds } from "../constant";
import DataTable from "../components/Tables/Datatable";
import { FiEdit2 } from "react-icons/fi";
import Loader from "../common/Loader";
import { useSelector } from "react-redux";
import ProductImageName from "../components/Layout/ProductImageName";
import { calcInStock, handleRouteNav } from "../utils";
import CustomBadge from "../components/Charts/CustomBadge";
import { ProductMorePagesButtons } from "./Products";

const ProductFavorites = () => {
  const { postApi, loading } = useApiCall();
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [productData, setProductData] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchParams, setSearchParams] = useSearchParams();
  const [totalCount, setTotalCount] = useState(0);
  const query = searchParams.get("q") || "";
  const { sort_no, short_name } = location.state || {};
  const { role_id } = useSelector((state) => state.auth);

  const handleRowClick = (record) => {
    navigate(handleRouteNav(`/product-details/${record.sort_no}`, role_id));
  };

  const onSearch = (value, _e, info) =>
    console.log(info === null || info === void 0 ? void 0 : info.source, value);

  const handleOnSearchChange = (e) => {
    const value = e.target.value;
    setSearchParams(
      (prev) => {
        if (value) prev.set("q", value);
        else prev.delete("q");
        return prev;
      },
      { replace: true },
    );
    setPage(1);
  };

  useEffect(() => {
    if (short_name) {
      setSearchParams(
        (prev) => {
          prev.set("q", short_name);
          return prev;
        },
        { replace: true },
      );
      setPage(1);
    }
  }, [short_name, setSearchParams]);

  const handleMenuClick = (e) => {
    // message.info("Click on menu item.");
    console.log("click", e);
  };

  const handleChange = (pagination, filters, sorter) => {
    setPage(pagination.pageSize !== perPage ? 1 : pagination.current);
    setPerPage(pagination.pageSize);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      const fetchProducts = async () => {
        try {
          const payload = {
            search: query,
            per_page: perPage,
            page,
          };
          if (sort_no) {
            payload.sort_no = sort_no;
          }
          const response = await postApi(
            "sales/wishlist/get-wishlist",
            payload,
          );
          if (!response || !response.data) {
            console.warn("API returned empty or invalid response:", response);
            setProductData([]);
            setTotalCount(0);
            return;
          }
          setTotalCount(response?.total);
          const formattedRows = (response.data || []).map((item) => ({
            ...item,
            productImageUrl: item.product?.product_pic_url,
          }));
          setProductData(formattedRows);
        } catch (error) {
          console.error("Error fetching products:", error);
        }
      };

      fetchProducts();
    }, 300);

    return () => clearTimeout(handler);
  }, [query, sort_no, page, perPage]);

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product",
      key: "product",
      render: (item) => (
        <ProductImageName
          img_url={item?.product_pic_url}
          img_alt={item?.quality?.short_name}
          text={
            <div>
              <div className="font-semibold">{item?.quality?.short_name}</div>
              <div className="text-xs text-gray-500">
                {item?.quality?.clienttype}
              </div>
            </div>
          }
        />
      ),
      ellipsis: true,
      width: 200,
    },
    // {
    //   title: "Price",
    //   dataIndex: "product",
    //   key: "product",
    //   render: (value) => `₹${value?.quality?.rate} / meter`,
    //   ellipsis: true,
    //   width: 140,
    // },
    {
      title: "Availability",
      dataIndex: "product",
      key: "product",
      render: (item) => {
        const isInStock = calcInStock(
          item?.quality?.quality_shade?.bsr_stock_cases,
          item?.quality?.quality_shade?.dcl_stockmtrs,
        );

        return (
          <div className="w-full flex items-center px-2 py-2">
            {isInStock ? (
              <CustomBadge variant="success" text="In Stock" />
            ) : (
              <CustomBadge variant="pending" text="Make to order" />
            )}
          </div>
        );
      },
      ellipsis: true,
      width: 140,
    },
    {
      title: "Width",
      dataIndex: "product",
      key: "product",
      render: (value) => `${Number(value?.quality?.finish_width) || 0}''`,
      ellipsis: true,
      width: 80,
    },
    {
      title: "Client Name",
      dataIndex: "customer",
      key: "customer",
      render: (value) => `${value?.company_name || "-"}`,
      ellipsis: true,
      width: 100,
    },
    {
      title: "Sales Person",
      dataIndex: "customer",
      key: "customer",
      render: (value) => `${value?.user?.full_name || "-"}`,
      ellipsis: true,
      width: 100,
    },
    // {
    //   title: "Actions",
    //   key: "action",
    //   width: 100,
    //   render: () => (
    //     <div className="flex gap-2 items-center">
    //       <Button className="rounded-xl text-lg py-1 px-2 w-20">
    //         <FaHeart className="text-[#A33434] text-lg" /> 32
    //       </Button>
    //       <Dropdown
    //         menu={{
    //           items: productsMenuItems,
    //           onClick: ({ key }) => {
    //             console.log(`Selected action: ${key}`);
    //           },
    //         }}
    //         trigger={["click"]}
    //         overlayClassName="custom-dropdown-sales-menu"
    //       >
    //         <Typography.Link onClick={(e) => e.preventDefault()}>
    //           <Space>
    //             <TbDotsVertical className="text-red-700" size={18} />
    //           </Space>
    //         </Typography.Link>
    //       </Dropdown>
    //     </div>
    //   ),
    // },
  ];

  const { setTitle, setDescription, setBackButton } = useOutletContext();

  useEffect(() => {
    setTitle("Favorite Products");
    setDescription(
      <div>
        <Breadcrumb>
          {[
            { title: "Home", href: handleRouteNav("/dashboard", role_id) },
            {
              title: "Product Catalogue ",
              href: handleRouteNav("/product-catalog", role_id),
            },
            {
              title: "Favorite Products",
              href: handleRouteNav("/product-catalog/favorites", role_id),
            },
          ].map((item, index) => (
            <Breadcrumb.Item key={index}>
              <Link to={item.href}>{item.title}</Link>
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </div>,
    );
    setBackButton(true);
  }, [setTitle, setDescription, setBackButton]);

  return (
    <>
      <>
        <div
          className="bg-[#FFFFFF]"
          style={{ borderRadius: "32px", overflow: "hidden" }}
        >
          <div className="flex justify-between gap-7 items-center px-8 py-6">
            <SearchInput
              onSearch={onSearch}
              value={query}
              onChange={handleOnSearchChange}
              placeholder="Search for products"
            />
          </div>
          <div className="flex flex-wrap justify-between px-8">
            <ProductMorePagesButtons
              activeButton={"favorites"}
              role_id={role_id}
            />

            <Button className="rounded-xl h-[42px] text-lg px-2 w-20 cursor-default">
              <FaHeart className="text-[#A33434] text-lg" />
              {totalCount || 0}
            </Button>
          </div>
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <Loader size={60} />{" "}
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={productData}
              handleChange={handleChange}
              handleRow={handleRowClick}
              pagination={{
                current: page,
                pageSize: perPage,
                total: totalCount,
                showSizeChanger: true,
              }}
            />
          )}
        </div>
      </>
    </>
  );
};

export default ProductFavorites;
